(function () {
  function showPanel(drawer, panelList, panelTarget) {
    const parts = String(panelTarget).split('-');
    const panelIndex = parseInt(parts[0], 10) || 0;
    const submenuIndex = parts.length > 1 ? parseInt(parts[1], 10) : 0;

    panelList.style.setProperty('--active-panel', panelIndex);
    panelList.setAttribute('data-active-panel', String(panelIndex));

    panelList.querySelectorAll('.bk-media-mobile-nav__panel').forEach(function (panel) {
      const idx = parseInt(panel.getAttribute('data-panel-index'), 10);
      if (idx !== panelIndex) return;

      panel.querySelectorAll('.bk-media-mobile-nav-submenu-panel').forEach(function (wrapper, wIdx) {
        wrapper.hidden = wIdx !== submenuIndex;
      });
    });
  }

  function updateMobileNavCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    const drawerCount = document.querySelector('[data-bk-mobile-nav-cart-count]');
    if (!drawerCount) return;

    drawerCount.textContent = cart.item_count;
  }

  function initBkMediaMobileNavCartCount() {
    document.documentElement.addEventListener('cart:updated', function (event) {
      updateMobileNavCartCount(event.detail && event.detail.cart);
    });

    document.documentElement.addEventListener('cart:refresh', function (event) {
      updateMobileNavCartCount(event.detail && event.detail.cart);
    });
  }

  function initMobileNavCartHandoff() {
    document.addEventListener('click', function (event) {
      const cartLink = event.target.closest('#mobile-menu-drawer .bk-media-mobile-nav__header-cart[aria-controls="mini-cart"]');
      if (!cartLink) return;

      const mobileDrawer = document.getElementById('mobile-menu-drawer');
      if (!mobileDrawer || !mobileDrawer.open) return;

      mobileDrawer.classList.add('bk-media-mobile-nav--closing-for-cart');
      mobileDrawer.open = false;

      requestAnimationFrame(function () {
        mobileDrawer.classList.remove('bk-media-mobile-nav--closing-for-cart');
      });
    }, true);
  }

  function initCartDrawerChatHide() {
    const cartDrawer = document.getElementById('mini-cart');
    if (!cartDrawer || cartDrawer.dataset.bkCartChatHideInit) return;

    cartDrawer.dataset.bkCartChatHideInit = 'true';

    const chatSelectors = [
      '#shopify-chat',
      'inbox-online-store-chat',
      '#dummy-chat-button-iframe',
      '#shopify-chat-iframe'
    ];

    function setChatHidden(hidden) {
      document.body.classList.toggle('is-cart-drawer-open', hidden);

      chatSelectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (element) {
          if (hidden) {
            element.style.setProperty('display', 'none', 'important');
            element.style.setProperty('visibility', 'hidden', 'important');
            element.style.setProperty('pointer-events', 'none', 'important');
            element.style.setProperty('opacity', '0', 'important');
          } else {
            element.style.removeProperty('display');
            element.style.removeProperty('visibility');
            element.style.removeProperty('pointer-events');
            element.style.removeProperty('opacity');
          }
        });
      });
    }

    function syncChatVisibility() {
      setChatHidden(cartDrawer.hasAttribute('open'));
    }

    const cartObserver = new MutationObserver(syncChatVisibility);
    cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });

    const chatObserver = new MutationObserver(function () {
      if (cartDrawer.hasAttribute('open')) {
        syncChatVisibility();
      }
    });
    chatObserver.observe(document.body, { childList: true, subtree: true });

    syncChatVisibility();
  }

  function initBkMediaMobileNavPanels() {
    const drawer = document.getElementById('mobile-menu-drawer');
    if (!drawer || drawer.dataset.bkMediaNavInitialized) return;

    const panelList = drawer.querySelector('.bk-media-mobile-nav__panel-list');
    if (!panelList) return;

    drawer.dataset.bkMediaNavInitialized = 'true';

    drawer.addEventListener('click', function (event) {
      const button = event.target.closest('[data-panel]');
      if (!button || !drawer.contains(button)) return;
      event.preventDefault();
      showPanel(drawer, panelList, button.getAttribute('data-panel'));
    });

    drawer.addEventListener('mobile-nav:close', function () {
      showPanel(drawer, panelList, '0');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBkMediaMobileNavPanels();
      initBkMediaMobileNavCartCount();
      initMobileNavCartHandoff();
      initCartDrawerChatHide();
    });
  } else {
    initBkMediaMobileNavPanels();
    initBkMediaMobileNavCartCount();
    initMobileNavCartHandoff();
    initCartDrawerChatHide();
  }

  document.addEventListener('shopify:section:load', function () {
    const drawer = document.getElementById('mobile-menu-drawer');
    if (drawer) delete drawer.dataset.bkMediaNavInitialized;
    initBkMediaMobileNavPanels();
    initBkMediaQuantityTierSelectors();

    const cartDrawer = document.getElementById('mini-cart');
    if (cartDrawer) delete cartDrawer.dataset.bkCartChatHideInit;
    initCartDrawerChatHide();
  });

  function bkFormatMoney(cents) {
    const format =
      (window.themeVariables &&
        window.themeVariables.settings &&
        (window.themeVariables.settings.currencyCodeEnabled
          ? window.themeVariables.settings.moneyWithCurrencyFormat
          : window.themeVariables.settings.moneyFormat)) ||
      '{{amount_with_comma_separator}} €';

    const normalized = typeof cents === 'string' ? parseInt(cents, 10) : cents;
    const amount = (normalized / 100).toFixed(2).replace('.', ',');

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount)
      .replace(/\{\{\s*amount\s*\}\}/, amount.replace(',', '.'));
  }

  class BkMediaQuantityTiers extends HTMLElement {
    getVariantData(variantId) {
      const raw = this.variantPrices[String(variantId)];

      if (raw && typeof raw === 'object') {
        return {
          price: raw.price || 0,
          compare_at_price: raw.compare_at_price || 0,
          unit_price: raw.unit_price || 0,
          unit_price_measurement: raw.unit_price_measurement || null
        };
      }

      return {
        price: raw || 0,
        compare_at_price: 0,
        unit_price: 0,
        unit_price_measurement: null
      };
    }

    calculateDiscountedUnitPrice(unitPrice, discountPercent) {
      if (!unitPrice) return 0;

      const unitDiscountAmount = Math.floor((unitPrice * discountPercent) / 100);
      return unitPrice - unitDiscountAmount;
    }

    getUnitPriceElements() {
      const elements = [];
      const productForm = this.closest('.product-form');
      const section = this.closest('.shopify-section');

      if (productForm) {
        productForm.querySelectorAll('.custom-unit-price-custom-sub').forEach(function (element) {
          if (elements.indexOf(element) === -1) {
            elements.push(element);
          }
        });
      }

      if (section) {
        section.querySelectorAll('.product-meta .custom-unit-price-custom-sub').forEach(function (element) {
          if (elements.indexOf(element) === -1) {
            elements.push(element);
          }
        });
      }

      return elements;
    }

    updateProductUnitPrice(discountPercent) {
      const variantData = this.getVariantData(this.currentVariantId);
      const baseUnitPrice = parseInt(
        variantData.unit_price ||
          this.getUnitPriceElements()[0]?.getAttribute('data-unit-price'),
        10
      );

      if (!baseUnitPrice) return;

      const discountedUnitPrice = this.calculateDiscountedUnitPrice(baseUnitPrice, discountPercent);
      const referenceUnit =
        (variantData.unit_price_measurement && variantData.unit_price_measurement.reference_unit) ||
        this.getUnitPriceElements()[0]?.getAttribute('data-unit-measurement') ||
        '';

      this.getUnitPriceElements().forEach(function (element) {
        const unit = element.getAttribute('data-unit-measurement') || referenceUnit;

        element.setAttribute('data-unit-price', String(baseUnitPrice));
        element.textContent = bkFormatMoney(discountedUnitPrice) + ' / ' + unit;
      });

      const stickyUnitPrice = document.querySelector(
        '.product-sticky-form__unit-price .unit-price-measurement__price'
      );

      if (stickyUnitPrice && referenceUnit) {
        stickyUnitPrice.textContent = bkFormatMoney(discountedUnitPrice);
      }
    }

    getSelectedTierButton() {
      return (
        this.querySelector('.bk-media-quantity-tier.is-selected') ||
        this.querySelector('.bk-media-quantity-tier[data-preselect="true"]') ||
        this.tierButtons[0]
      );
    }

    getPriceListContainers() {
      const productForm = this.closest('.product-form');
      const containers = [];

      if (productForm) {
        const formPriceList = productForm.querySelector('[data-product-price-list]');
        if (formPriceList) {
          containers.push(formPriceList);
        }
      }

      const stickyPriceList = document.querySelector('[data-product-price-list-sticky]');
      if (stickyPriceList && containers.indexOf(stickyPriceList) === -1) {
        containers.push(stickyPriceList);
      }

      return containers;
    }

    updateProductPriceList() {
      const selectedButton = this.getSelectedTierButton();
      if (!selectedButton) return;

      const qty = parseInt(selectedButton.dataset.qty, 10) || 1;
      const discountPercent = parseInt(selectedButton.dataset.discountValue, 10) || 0;
      const variantData = this.getVariantData(this.currentVariantId);
      const variantPrice = variantData.price;
      const compareAt = variantData.compare_at_price || 0;
      const prices = this.calculateTierPrices(variantPrice, qty, discountPercent, 0);
      const compareUnit = compareAt > variantPrice ? compareAt : variantPrice;
      const totalCompare = compareUnit * qty;
      const showCompare = compareAt > variantPrice || discountPercent > 0;
      const saleLabel =
        (window.themeVariables &&
          window.themeVariables.strings &&
          window.themeVariables.strings.productSalePrice) ||
        'Sale price';
      const regularLabel =
        (window.themeVariables &&
          window.themeVariables.strings &&
          window.themeVariables.strings.productRegularPrice) ||
        'Regular price';

      let priceHtml = '';

      if (showCompare) {
        priceHtml +=
          '<span class="price price--highlight price--large" data-ed-price="' +
          variantPrice +
          '"><span class="visually-hidden">' +
          saleLabel +
          '</span>' +
          bkFormatMoney(prices.totalFinal) +
          '</span>';
        priceHtml +=
          '<span class="price price--compare price--large" data-ed-compare-price="' +
          compareUnit +
          '"><span class="visually-hidden">' +
          regularLabel +
          '</span>' +
          bkFormatMoney(totalCompare) +
          '</span>';
      } else {
        priceHtml +=
          '<span class="price price--large" data-ed-price="' +
          variantPrice +
          '"><span class="visually-hidden">' +
          saleLabel +
          '</span>' +
          bkFormatMoney(prices.totalFinal) +
          '</span>';
      }

      this.getPriceListContainers().forEach(function (priceList) {
        priceList.innerHTML = priceHtml;

        const container = priceList.closest('.product-meta__price-list-container');
        if (!container) return;

        const labelList = container.querySelector('[data-product-label-list]');
        const savingsAmount = totalCompare - prices.totalFinal;

        if (!labelList) return;

        if (showCompare && savingsAmount > 0) {
          labelList.innerHTML =
            '<span class="label label--highlight">Du sparst <span class="ed-save-amount">' +
            bkFormatMoney(savingsAmount) +
            '</span></span>';
          labelList.hidden = false;
        } else if (discountPercent <= 0 && compareAt <= variantPrice) {
          labelList.innerHTML = '';
        }
      });

      this.updateProductUnitPrice(discountPercent);
    }

    connectedCallback() {
      this.formId = this.dataset.formId;
      this.perDayPrefix = this.dataset.perDayPrefix || '';
      this.perDaySuffix = this.dataset.perDaySuffix || '';
      this.savingsPrefix = this.dataset.savingsPrefix || 'Du sparst';
      this.tierButtons = this.querySelectorAll('.bk-media-quantity-tier');
      this.quantityInput = this.querySelector('.bk-media-quantity-tiers__input');
      this.variantPrices = this.readVariantPrices();
      this.tierConfig = this.readTierConfig();
      this.currentVariantId = this.dataset.initialVariantId;

      const initialVariant = this.getVariantData(this.currentVariantId);
      this.currentVariantPrice = initialVariant.price;
      this.currentVariantComparePrice = initialVariant.compare_at_price || initialVariant.price;

      this.tierButtons.forEach(function (button) {
        button.addEventListener('click', this.onTierClick.bind(this));
      }, this);

      this.onVariantChanged = this.onVariantChanged.bind(this);
      const form = document.getElementById(this.formId);
      if (form) {
        form.addEventListener('variant:changed', this.onVariantChanged);
      }

      this.updateAllTierPrices(this.currentVariantPrice);

      const selectedButton = this.getSelectedTierButton();

      if (selectedButton) {
        this.selectTier(selectedButton, false);
        this.updateProductPriceList();
        this.dispatchSelectedTierChange();
      }
    }

    disconnectedCallback() {
      const form = document.getElementById(this.formId);
      if (form) {
        form.removeEventListener('variant:changed', this.onVariantChanged);
      }
    }

    readVariantPrices() {
      const section = this.closest('.shopify-section');
      const script =
        (section && section.querySelector('[data-bk-quantity-tier-variants]')) ||
        document.querySelector('[data-bk-quantity-tier-variants]');
      if (!script) return {};

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return {};
      }
    }

    readTierConfig() {
      const script = document.querySelector('[data-bk-quantity-tier-config]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return [];
      }
    }

    onVariantChanged(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant || typeof variant.price === 'undefined') return;

      this.currentVariantId = String(variant.id);
      this.currentVariantPrice = variant.price;
      this.currentVariantComparePrice = variant.compare_at_price || variant.price;
      this.variantPrices[this.currentVariantId] = {
        price: variant.price,
        compare_at_price: variant.compare_at_price || 0,
        unit_price: variant.unit_price || 0,
        unit_price_measurement: variant.unit_price_measurement || null
      };
      this.updateAllTierPrices(variant.price);
      this.updateProductPriceList();
      this.dispatchSelectedTierChange();

      const self = this;
      const selectedButton = this.getSelectedTierButton();
      const discountPercent = selectedButton ? parseInt(selectedButton.dataset.discountValue, 10) || 0 : 0;

      requestAnimationFrame(function () {
        self.updateProductUnitPrice(discountPercent);
      });
    }

    dispatchSelectedTierChange() {
      const selectedButton = this.getSelectedTierButton();

      if (!selectedButton) return;

      document.dispatchEvent(
        new CustomEvent('ed:qty:discount:change', {
          detail: {
            value: selectedButton.dataset.qty,
            discountType: selectedButton.dataset.discountType,
            discountValue: selectedButton.dataset.discountValue
          }
        })
      );
    }

    onTierClick(event) {
      this.selectTier(event.currentTarget, true);
    }

    selectTier(button, dispatchEvent) {
      this.tierButtons.forEach(function (tierButton) {
        tierButton.classList.remove('is-selected');
        tierButton.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');

      if (this.quantityInput) {
        this.quantityInput.value = button.dataset.qty;
      }

      this.updateProductPriceList();

      if (dispatchEvent) {
        document.dispatchEvent(
          new CustomEvent('ed:qty:discount:change', {
            detail: {
              value: button.dataset.qty,
              discountType: button.dataset.discountType,
              discountValue: button.dataset.discountValue
            }
          })
        );
      }
    }

    calculateTierPrices(variantPrice, qty, discountPercent, days) {
      const unitDiscountAmount = Math.floor((variantPrice * discountPercent) / 100);
      const unitFinalPrice = variantPrice - unitDiscountAmount;
      const totalFinal = unitFinalPrice * qty;
      const totalCompare = variantPrice * qty;
      const pricePerDay = days > 0 ? unitFinalPrice / days : null;

      return {
        totalFinal: totalFinal,
        totalCompare: totalCompare,
        unitFinalPrice: unitFinalPrice,
        pricePerDay: pricePerDay,
        discountPercent: discountPercent
      };
    }

    updateAllTierPrices(variantPrice) {
      const self = this;

      this.tierButtons.forEach(function (button) {
        const qty = parseInt(button.dataset.qty, 10) || 1;
        const discountPercent = parseInt(button.dataset.discountValue, 10) || 0;
        const days = parseInt(button.dataset.days, 10) || 0;
        const prices = self.calculateTierPrices(variantPrice, qty, discountPercent, days);

        const unitEl = button.querySelector('[data-tier-unit]');
        const compareEl = button.querySelector('[data-tier-compare]');
        const badgeEl = button.querySelector('[data-tier-badge]');
        const perDayEl = button.querySelector('.bk-media-quantity-tier__per-day');

        if (unitEl) {
          unitEl.textContent = bkFormatMoney(prices.unitFinalPrice);
          unitEl.classList.toggle('price--highlight', discountPercent > 0);
        }

        if (compareEl) {
          if (discountPercent > 0) {
            compareEl.textContent = bkFormatMoney(variantPrice);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        if (badgeEl) {
          if (discountPercent > 0) {
            badgeEl.textContent = self.savingsPrefix + ' ' + discountPercent + '%';
            badgeEl.hidden = false;
          } else {
            badgeEl.hidden = true;
          }
        }

        if (perDayEl) {
          if (days > 0 && prices.pricePerDay != null) {
            perDayEl.textContent =
              self.perDayPrefix +
              ' ' +
              bkFormatMoney(Math.round(prices.pricePerDay)) +
              (self.perDaySuffix ? ' ' + self.perDaySuffix : '');
            perDayEl.hidden = false;
          } else {
            perDayEl.hidden = true;
          }
        }
      });
    }
  }

  if (!customElements.get('bk-media-quantity-tiers')) {
    customElements.define('bk-media-quantity-tiers', BkMediaQuantityTiers);
  }

  function initBkMediaQuantityTierSelectors() {
    document.querySelectorAll('bk-media-quantity-tiers:not([data-bk-tier-init])').forEach(function (element) {
      element.setAttribute('data-bk-tier-init', 'true');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBkMediaQuantityTierSelectors, { once: true });
  } else {
    initBkMediaQuantityTierSelectors();
  }
})();
